import React from 'react'
import { Link } from 'react-router-dom'
import useScrollAnimation from '../hooks/useScrollAnimation'
import './featured-projects.css'

const projects = [
  {
    title: 'Manasara AI',
    tag: 'Y Combinator Top 5%',
    description:
      'AI-powered platform automating building code compliance checks, integrating with BIM tools and reducing design validation time by 60%.',
    image: '/screenshot%202025-06-15%20at%2011.45.05%C3%A2%C2%80%C2%AFam-300h.png',
    link: 'https://manasara-ai.com/',
    external: true,
  },
  {
    title: 'Geometry Factory',
    tag: '3D Configuration Platform',
    description:
      'Interactive web-based platform for designing and configuring 3D geometric assemblies in real-time using Three.js and WebGL.',
    image: '/prefab%20software-300h.png',
    link: 'https://abhipalit3.github.io/Geometry-Factory/',
    external: true,
  },
]

const FeaturedProjects = () => {
  const [sectionRef, isSectionVisible] = useScrollAnimation()

  return (
    <section
      ref={sectionRef}
      className={`featured-section ${isSectionVisible ? 'animate-in' : ''}`}
    >
      <div className="featured-container">
        <div className="featured-header">
          <h2 className="featured-heading">Featured Projects</h2>
          <Link to="/projects" className="featured-view-all">
            View all projects
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
        <div className="featured-grid">
          {projects.map((project, index) => (
            <a
              key={index}
              href={project.link}
              target="_blank"
              rel="noreferrer noopener"
              className="featured-card-link"
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="featured-card">
                <div className="featured-card-image">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="featured-card-content">
                  <span className="featured-card-tag">{project.tag}</span>
                  <h3 className="featured-card-title">{project.title}</h3>
                  <p className="featured-card-description">{project.description}</p>
                  <span className="featured-card-cta">
                    Explore project
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M7 17L17 7M7 7h10v10" />
                    </svg>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturedProjects
